import loadBalancers from './loadBalancers';
import loadBalancerPools from './loadBalancerPools';

export default {
  namespaced: true,
  name: 'lbaas',
  modules: {
    loadBalancers,
    loadBalancerPools,
  }
};
